import logo from "@/assets/images/bomiel.png";

/**
 * セッション復元（`GET /auth`）が解決するまで表示する全画面スプラッシュ。
 *
 * index.html のブートローダー（JS 読み込み前に出る同じ見た目の静的 HTML）と
 * 揃えてあり、「白画面 → ローダー → アプリ」を継ぎ目なく見せる。
 * ngtg_msc の Flutter 側 _SessionSplash に対応する。
 */
export default function SessionSplash() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-white">
      <img src={logo} alt="BOMIEL" width={140} height={140} />
      <div className="mt-7 size-[72px] animate-spin rounded-full border-6 border-brand-100 border-t-brand-500" />
      <p className="mt-5 text-[15px] text-brand-500">読み込み中...</p>
    </div>
  );
}
